import type { DocumentApproval } from "../api/generated";
import type { DocumentWorkflowDocument } from "../entities/document-workflow";

export const approvalStatusLabels: Record<DocumentApproval["status"], string> =
  {
    in_progress: "На согласовании",
    returned: "Возвращено на доработку",
    approved: "Согласовано",
    rejected: "Отклонено",
    withdrawn: "Отозвано",
  };
export const approvalTaskLabels = {
  pending: "Ожидает",
  approved: "Согласовал",
  returned: "Вернул на доработку",
  rejected: "Отклонил",
  not_required: "Не требуется",
  cancelled: "Отменено",
} as const;
export const approvalDecisions = {
  approve: "Согласовать",
  return: "Вернуть на доработку",
  reject: "Отклонить",
} as const;
export type ApprovalDecision = keyof typeof approvalDecisions;

export const documentApprovalsKey = (id: string) =>
  ["document-workflow", "documents", id, "approvals"] as const;

export function approvalRecipientTask(
  approval: DocumentApproval,
  userId: string,
) {
  if (approval.status !== "in_progress") return undefined;
  return approval.rounds
    .find((round) => round.round === approval.current_round)
    ?.steps.filter((step) => step.status === "active")
    .flatMap((step) => step.tasks)
    .find(
      (task) =>
        task.state === "pending" &&
        (task.routed_to ?? task.approver).id === userId,
    );
}

export function canStartApproval(
  document: Pick<DocumentWorkflowDocument, "owner_id" | "owner" | "status">,
  userId: string,
  permissions: readonly string[],
) {
  return (
    !["completed", "cancelled"].includes(document.status) &&
    (document.owner_id === userId ||
      document.owner?.id === userId ||
      permissions.includes("document-workflow.approvals.start") ||
      permissions.includes("*"))
  );
}
